import { useMemo } from "react";
import { toStarRating } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { HotelInfoSectionProps } from "./HotelInfoSection";
import { calculatePointsEarnedForLodging } from "@/utils/points";

export const useHotelInfoSection = ({ hotel }: HotelInfoSectionProps) => {
  const { lodging, isFreeCancel } = hotel;
  const reviews = lodging.tripAdvisorReviews;
  const rewardsAmount = calculatePointsEarnedForLodging(hotel);
  const { t } = useI18nContext();

  return useMemo(() => {
    //Out of 5 stars
    return {
      context: {
        tripAdvisorReviews: reviews,
        rewardsAmount: rewardsAmount,

        isFreeCancel,
      },
      text: {
        hotelName: lodging.name,
        starRating: t("core-hotels.availabilityPage.results.hotelCard.stars", {
          count: toStarRating(lodging.starRating),
        }),
        freeCancellation: t(
          "core-hotels.availabilityPage.results.hotelCard.features.freeCancellation"
        ),
      },
    };
  }, [lodging, reviews, isFreeCancel, rewardsAmount, t]);
};
